import { SectionWrapper } from "../hoc";
import { styles } from "../styles";
import "./Cv.css";
import { FaFileDownload } from "react-icons/fa";

const Cv = () => {
  return (
    <div className="flex flex-col justify-center align-middle gap-8 min-h-screen">
      <div>
        <h1 className={`${styles.heroHeadText} text-white`}>
          <span className="text-[#915eff]">CV</span> Files
        </h1>
        <p className={`${styles.heroSubText} mt-2 text-white-100`}>
          CV is available in english language.
        </p>
      </div>
      <div className="mx-auto">
        <span className="text-9xl">
          <FaFileDownload color="white" />
        </span>
      </div>
    </div>
  );
};

export default SectionWrapper(Cv, false);
